<div class="page-content page-fill flex-row">
  <!-- <div class="col-sm-4 p-0">
  <div class="mb-1 paddle-header">Paddle Assignment (DoubleClick row to assign paddle)</div>
  <div *ngIf="auctionPaddleInfos" class="grid-fill reconciliation-data-grid" style="max-width: 99%">
    <dx-data-grid
      #paddleDataGrid
      [dataSource]="auctionPaddleInfos"
      keyExpr="id"
      height="100%"
      [showBorders]="true"
      [columnAutoWidth]="false"
      [focusedRowEnabled]="false"
      [showColumnLines]="true"
      [wordWrapEnabled]="true"
      (onToolbarPreparing)="onPaddleToolbarPreparing($event)"
      (onRowDblClick)="paddleRowDoubleClick($event)"
      >
      <dxi-column dataField="paddleNumber" caption="Paddle#" width="100" [sortIndex]="1" [sortOrder]="'asc'" [alignment]="'left'"></dxi-column>
      <dxi-column dataField="assignedTo" caption="Assigned To" width="300"></dxi-column>
      <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
      <dxi-column width="50"></dxi-column>

      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="paddle-list-grid"></dxo-state-storing>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-selection [mode]="'single'"></dxo-selection>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          class="btn btn-sm btn-danger me-4"
          (click)="deletePaddleUser(paddleDataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="paddleDataGrid.instance.getSelectedRowsData().length === 0"
          >
          Delete Paddle
        </button>
        <button class="btn btn-sm btn-primary me-4" (click)="createInvoice()">Create Invoice</button>
        <button class="btn btn-sm btn-secondary" (click)="getData()">Refresh Data</button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
      </div>
    </dx-data-grid>
  </div>
</div> -->
<div class="col-sm-12">
  @if (nonDepositedBatches) {
    <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
      <dx-data-grid
        #dataGrid
        [dataSource]="nonDepositedBatches"
        keyExpr="id"
        height="100%"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="itemRowDoubleClick($event)"
        (onRowPrepared)="rowPrepare($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        >
        <dxi-column dataField="id" caption="Id" width="70" [sortIndex]="1" [sortOrder]="'asc'" [alignment]="'left'"></dxi-column>
        <dxi-column dataField="date" caption="Date" dataType="date" width="100"></dxi-column>
        <dxi-column dataField="bagNumber" caption="Bag#" width="50" [alignment]="'left'"></dxi-column>
        <dxi-column dataField="name" width="515"></dxi-column>
        <dxi-column dataField="batchTotalAmount" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="batchTotalAmountForGeneralFund" caption="GF Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="specialAccount.qbAccountDisplay" caption="Acct" width="300"></dxi-column>
        <dxi-column dataField="deposited" dataType="date" width="100"></dxi-column>
        <dxi-column dataField="status.name" caption="Status" width="100"></dxi-column>
        <dxi-column dataField="note" width="200"></dxi-column>
        <dxi-column width="120"></dxi-column>
        <dxo-summary>
          <dxi-total-item column="batchTotalAmount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
          <dxi-total-item column="batchTotalAmountForGeneralFund" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }">
          </dxi-total-item>
        </dxo-summary>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="auction-items-list-grid"></dxo-state-storing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
        <dxo-sorting [mode]="'multiple'"></dxo-sorting>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-sm btn-primary" (click)="markAsDeposited()" [disabled]="true" >Mark Deposited</button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (nonDepositedBatches) {
            <span class="ms-3">
              <strong>Selected Amount: {{ selectedAmount | currency }}</strong>
            </span>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarSelect'">
          <dx-select-box class="ms-3" [items]="months" displayExpr="name" valueExpr="id" placeholder="Select Month" (onValueChanged)="onMonthChanged($event)"> </dx-select-box>
        </div>
      </dx-data-grid>
    </div>
  }
</div>
</div>
